var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"floatButton",staticClass:"backHome",style:({
			width: _vm.itemWidth + 'px',
			height: _vm.itemHeight + 'px',
			left: _vm.left + 'px',
			top: _vm.top + 'px',
		}),on:{"click":_vm.goCreatePage}},[_c('img',{attrs:{"src":_vm.iconPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }